// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3j5Aa","containerItemsCenter":"Skeleton_containerItemsCenter__BI95F"};